<template>
	<div class="goods">
		<v-head :title="title"></v-head>
		<div class="content">
			<!-- <div class="fontsBox">
				线下支付银行账号信息： 开户名称：中国地震学会。   开 户 行：工行海
				淀西区紫竹院支行    银行卡号：0200007619201134580 <br/>
				注：1、线上缴费成功后成为正式会员<br/>
				       2、线下缴费需要上传缴费凭证，提交后学会财务处进行审核，待审
				核通过后成为正式会员
			</div>    -->
		    <div class="order-list">
           <div class="warmTips" v-if="orderList.content && !orderList.content.length">
              <img src="../../assets/images/404.png"/>
              <span>没有找到相应内容哦</span>
            </div>
				    <template v-for="item in orderList.content">
				        <v-order
				          :item="item"
				          :key="item.title"
				          :isWXPay="isWXPay"
				          from="member"
				          @onLine="onLine"
				          @getDate="getDate"
				        ></v-order>
				    </template>
	        </div>
		</div>
	</div>
</template>
<script>
import {
  baseURL,
  getPaymentList,
  createOrder,
  SockJSURL,
  getUser,
  memberAudit,
  getMeetingPaymentList
} from "@/api/dictionary";	
import vHead from "../../components/Subhead.vue";
import vOrder from "../../components/order.vue";
import {getSessionStore} from "@/utils/sessionStorage.js"
import { Uploader,Toast,Button,ImagePreview,ActionSheet,Dialog} from "vant";
import { mapGetters ,mapState} from "vuex";

export default {
  data() {
    return {
     show: false,
     fileList: [],
     photoList:[],
     memberDues:[],
      pay:false,
      loading: true,
      value: "",
      size: 300,
      codeUrl: null,
      baseURL: baseURL,
      dialogOnline: false,
      socket: null,
      isSelect: false,
      refresh: false,
      page: 1,
      orderTip: "",
      payStatus: 0,
      isWXPay: true,
      orderList: {
        content: []
      },
      mode: 1,
      message: {
        id: "",
        name: "111"
      },
      list: {
        content: []
      },
      params:{
        amount:null,
        price:null
      },
      title:"会议缴费"
    };
  },
  components: {
    vHead,
    vOrder,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [ImagePreview.name]: ImagePreview,
    [ActionSheet.name]: ActionSheet,
	[Dialog.Component.name]:Dialog.Component
  },
  computed: {
    ...mapGetters(["isGroupMember"]),
    ...mapState(["userInfo"])
  },
  methods: {
	  go(pathName) {
	      this.$router.push({ name: pathName });
	  },
    getDate: function() {
		const token = getSessionStore("access_token");
		const memberId = getSessionStore("memberId");
        this.loading = true;
		getMeetingPaymentList({ orderType: 2 ,"access_token":token,"memberId":memberId}, this.page - 1)
        .then(res => {
          if (res.success) {
            this.orderList = res.result;
          }
        })
        .catch(() => {
          this.$message.error("获取数据失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changePage: function(val) {
      this.page = val;
      this.getDate();
    },
    onLine(item) {
	    this.dialogOnline = true;
	    this.getWXPay(item);
    },
    goMemberPay() {
      this.$router.push({ name: "memberPay", query: { orderType: 1 } });
    },
    getOrderMessage: function() {
      getOrderMessage().then(data => {
        this.orderTip = data;
      });
    },

    goPay: function(obj) {
      this.$router.push({
        name: "memberPay",
        query: {
          payId: obj.id,
          price: obj.price,
          number: obj.number,
          orderType: obj.orderType,
          memberCount: obj.memberCount,
          memberFileId: obj.memberFileId,
          orderAmount: obj.orderAmount
        }
      });
    },
  },
   mounted() {
    //this.getOrderMessage();
    this.getDate();
  }
};
</script>

<style  lang="less" scoped>
.Payment{    
    position: absolute;
    z-index: 9999;
    right: 20px;
    top: 17px;
    color: #fff;
}

.Order{ background: #fafafa; padding:15px 0; margin-top: 15px; }
.Order p{ line-height: 24px; color: #848484; }
.fontsBox{ 
	width: 84%;
	margin:20px auto 0 auto;
	background: #fff6ec; 
	padding:14px; 
	font-size: 13px;
	border: #f6d0a2 dashed 1px;
	line-height: 22px;
	color: #ffbe4e;
}
.warmTips,.orderTip{     font-size: 16px;
    text-align: center;
    margin-top: 25%; }
</style>